export const reportsEn = {
  title: "Administration",
  placeholder: "Enterprise reports and the customizable assessment.",
  tabs: {
    enterprises: "Enterprises",
    progress: "Progress",
    assessment: "Customizable assessment",
    search: "Search",
    partners: "Partners",
    promoCodes: "Promotional codes",
  },
  filters: {
    heading: "Filters",
    keyword: "Keyword",
    keywordPlaceholder: "Keywords (name, city, etc.)",
    keywordPlaceholderProgress: "Keywords",
    region: "Region",
    allRegions: "All regions",
    mrc: "MRC",
    allMrcs: "All MRCs",
    allCities: "All cities",
    allProvinces: "All provinces",
    partnerGroup: "Partner group",
    allPartnerGroups: "All groups",
    advanced: "Advanced search",
    province: "Province",
    dateFrom: "Start date",
    dateTo: "End date",
    dateOrder: "Start date must precede or be equal to end date",
    monthPlaceholder: "mm/yyyy",
    sectorCategory: "Business sector",
    allCategories: "All business sectors",
    sectors: "Business sub-sectors",
    allSectors: "All business sub-sectors",
    answerType: "Answer type",
    allAnswerTypes: "All answer types",
    issues: "Issues",
    allIssues: "All issues",
    goals: "Objectives",
    allGoals: "All objectives",
    actions: "Actions",
    allActions: "All actions",
    removeFilter: "Remove filter",
    search: "Search…",
    noMatch: "No match",
    reset: "Reset",
    apply: "Apply",
  },
  columns: {
    name: "Name",
    city: "City",
    region: "Region",
    partnerGroups: "Partner group",
    sectors: "Sectors",
    type: "Type",
    currentStep: "Current step",
    lastLogin: "Last login date",
    accountCreated: "Account creation date",
    contact: "Contact",
    email: "Email",
  },
  steps: {
    step_0: "Company profile created",
    step_1: "Self-assessment started",
    step_2: "Self-assessment completed",
    step_3: "Action plan created",
    step_4: "Action plan follow-up started",
    step_5: "Approval requested",
    step_6: "Communication published",
  },
  detail: {
    title: "Enterprise profile",
    close: "Close",
    contact: "Contact details",
    owner: "Owner",
    address: "Address",
    sectors: "Activity sectors",
    characteristics: "Characteristics",
    companySize: "Number of employees",
    consents: "Consents",
    consentProgress: "Progress",
    consentDiagnostic: "Self-assessment",
    consentEdit: "Editing",
    granted: "Granted",
    notGranted: "Not granted",
    progress: "Progress",
    description: "Description",
    phone: "Phone",
    mrc: "MRC",
    account: "Account",
    subscriptionStatus: "Subscription status",
    couponsUsed: "Coupons used",
    accountCreated: "Account created",
    lastLogin: "Last login",
    subStatus: {
      active: "Active",
      incomplete: "Incomplete",
      incomplete_expired: "Incomplete (expired)",
      past_due: "Past due",
      canceled: "Canceled",
      unpaid: "Unpaid",
    },
    communication: "Communication",
    publicationStatus: "Publication status",
    pubNone: "No request",
    pubRequested: "Requested on {{date}}",
    pubPublished: "Approved and published on {{date}}",
    lastCommunication: "Last communication",
    actionPlans: "Action plans",
    untitledPlan: "Untitled plan",
    relatedProfiles: "Profiles in the same group",
    none: "—",
  },
  assessment: {
    totalEnterprises: "Enterprises",
    signUps: "Sign-ups",
    signUpsPerMonth: "Sign-ups per month",
    completedQuestionnaire: "Completed questionnaires",
    completedActionPlan: "Completed action plans",
    publishedCommunication: "Published communications",
    activeUsers: "Active users",
    progression: "Progression",
    bySector: "Enterprises by activity sector",
    byPartnerGroup: "Enterprises by partner group",
    byStep: "Distribution by step",
    byThematic: "Courses of action & achievements",
    carriedOut: "Completed actions",
    courseOfAction: "Courses of action",
    drilldownHint: "Click a row to drill in: theme → issue → objective → action → companies.",
    progressionHint: "Click a stage to see the companies at that step.",
    back: "Back",
    levels: {
      thematic: "Themes",
      issue: "Issues",
      goal: "Objectives",
      action: "Actions",
      enterprise: "Enterprises",
    },
  },
  search: {
    description:
      "Search enterprises by keyword and by their questionnaire answers (issues, objectives, actions).",
  },
  csv: {
    export: "Export to CSV",
    exportProgress: "Export progress",
    exportAssessment: "Export assessment",
    failed: "The export failed.",
  },
  state: {
    loading: "Loading…",
    error: "An error occurred while loading data.",
    empty: "No enterprise matches the filters.",
    results_one: "{{count}} enterprise",
    results_other: "{{count}} enterprises",
    previous: "Previous",
    next: "Next",
    page: "Page {{page}}",
  },
} as const;
